<template>
<div class="preview-field">
  <div ref="elt" :class="fieldClass">
    <div class="row">
      <div class="col-xs-12">
        <div v-if="fieldType === 'pickList'">
          <pick-list class="pick-list"
                     :selected="selected"
                     :value="value"
                     :note="note"
                     :parameters="parameters"
                     @commit="commit($event, false)"
                     @select="select()">
          </pick-list>
        </div>
        <div v-else-if="fieldType === 'bool'">
          <toggle :value="value"
               :selected="selected"
               :note="note"
               :parameters="parameters"
               @commit="commit($event, false)"
               @select="select()">
          </toggle>
        </div>
        <div v-else>
          <field :type="fieldType"
                 :selected="selected"
                 :parameters="fieldParameters"
                 :value="value"
                 :note="note"
                 @commit="commit($event, true)"
                 @select="select()"/>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import field from '@/sui/components/sheet/add/field'
import pickList from '@/sui/components/sheet/add/pickList'
import toggle from '@/sui/components/sheet/add/toggle'

export default {
  name: 'sheet-add-preview-field',
  props: {
    parameters: {
      type: Object,
      required: true
    },

    value: {
      required: true
    },

    note: {
      type: Object,
      required: true
    },

    selected: {
      type: Boolean,
      required: true
    }
  },

  watch: {
    value: {
      handler (v) {
        this.data = v
      },
      deep: true
    },

    selected (v) {
      if (v) {
        this.$nextTick(function () {
          const rect = this.$refs.elt.getBoundingClientRect()
          const top = rect.top + window.pageYOffset ||
                document.documentElement.scrollTop
          const offset = window.innerHeight / 4
          window.scrollTo(0, top - offset)
        })
      }
    }
  },

  data: function () {
    return {
      data: this.value
    }
  },

  methods: {
    commit: function (e, goToNextStep) {
      this.$emit(
        'commit',
        { e: e, goToNextStep: goToNextStep }
      )
    },

    select: function () {
      if (!this.selected) {
        this.$emit('select')
      }
    }
  },

  computed: {
    fieldType: function () {
      return this.parameters.config.type
    },

    result: function () {
      if (this.data != null) {
        return this.data
      }

      return '_ _'
    },

    fieldClass: function () {
      return {
        highlighted: this.selected,
        basic: !this.selected && !this.parameters.config.readOnly,
        accentuated: this.parameters.config.accentuated,
        disabled: this.parameters.config.readOnly
      }
    },

    fieldParameters: function () {
      return {
        context: this.parameters.context,
        readOnly: this.parameters.config.readOnly,
        indentation: this.parameters.indentation,
        hint: this.parameters.hint,
        autoNext: this.parameters.autoNext
      }
    }
  },

  components: {
    'field': field,
    'pick-list': pickList,
    'toggle': toggle
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.preview-field {
    .basic {
        cursor: pointer;
        border: 1px solid transparent;
        padding: 0.1rem 0rem;
    }

    .accentuated {
        background-color: #FFFCCD;
        border-radius: 3px;
    }

    .basic:hover {
        padding: 0.1rem 0.3rem;
        margin-left: -0.5rem;
        margin-right: -0.5rem;
        border-radius: 5px;
        border: 1px solid lighten(@base, 25%);
        border-left: 5px solid lighten(@base, 25%);
    }

    .disabled:hover {
        cursor: not-allowed;
    }

    .highlighted {
        margin-left: -0.5rem;
        margin-right: -0.5rem;
        border-radius: 5px;
        padding: 0.1rem 0.5rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 1px solid @base;
        border-left: 5px solid @base;
    }
}

</style>
